import customSelect from 'custom-select';

if (jQuery('select').length) {
  document.querySelectorAll('select').forEach(function (item) {
    var select = item;
    var queryString = window.location.search;

    if (queryString) {
      var urlParams = new URLSearchParams(queryString);
      var term_industry = urlParams.get('industry');
      var term_function = urlParams.get('function');
      var select_id = select.id;

      if (select_id == 'job_function') {
        var flag = false;
        jQuery('#' + select_id).find('option').each(function () {
          if (jQuery(this).val() == term_function) {
            flag = true;
          }
        });

        if (flag) {
          jQuery('#' + select_id).val(term_function);
          jQuery('.job-board__table-tbody.list .job-board__table-row').each(function () {
            var item = jQuery(this);

            if (item.hasClass(term_function)) {
              item.show();
            } else {
              item.hide();
            }
          });
        }
      } else if (select_id == 'job_industry') {
        var _flag = false;
        jQuery('#' + select_id).find('option').each(function () {
          if (jQuery(this).val() == term_industry) {
            _flag = true;
          }
        });

        if (_flag) {
          jQuery('#' + select_id).val(term_industry);
          jQuery('.job-board__table-tbody.list .job-board__table-row').each(function () {
            var item = jQuery(this);

            if (item.hasClass(term_industry)) {
              item.show();
            } else {
              item.hide();
            }
          });
        }
      }
    }

    customSelect(select);
  });
}